import React, { useContext } from 'react';
import DropdownContext from '../../context';

const DropdownTrigger = ({ children }) => {
  const { refs, getReferenceProps } = useContext(DropdownContext);

  return (
    <div className="ws-ui-dropdown__trigger" ref={refs.setReference} {...getReferenceProps()}>
      {children}
    </div>
  );
};

export default DropdownTrigger;
